import * as React from "react";
import "./PatientAppointments.scss";
import HeaderBar from "../commons/components/HeaderBar";
import { AppointmentsPanel, AppointmentUrls } from "./AppointmentsPanel";
import MobileApplicationView from "./MobileApplicationView";
import MobileApplicationLink from "./MobileApplicationLink";
import { createRoot } from "react-dom/client";

export default function PatientAppointments({
  appointmentUrls,
  mobileApplicationView,
}: {
  appointmentUrls: AppointmentUrls;
  mobileApplicationView: MobileApplicationView;
}) {
  return (
    <>
      <HeaderBar
        title={i18n["Page.Portal.PatientAppointment.Title"]}
        action={
          mobileApplicationView && (
            <MobileApplicationLink mobileApplicationView={mobileApplicationView} />
          )
        }
      />
      <div className="container h-flex centered">
        <AppointmentsPanel {...appointmentUrls} title={"Page.Portal.PatientAppointment.Subtitle"} />
      </div>
    </>
  );
}

PatientAppointments.loadComponent = (elementId: string, props) => {
  const container = document.getElementById(elementId);
  const root = createRoot(container!);
  root.render(<PatientAppointments {...props} />);
};
